import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name: 'loader',
    initialState: {},
    reducers: {
        startLoading: (state, action) => {
            state[action.payload] = true;
        },
        stopLoading: (state, action) => {
            state[action.payload] = false;
        },
    }
});

export const { startLoading, stopLoading } = loaderSlice.actions;

export default loaderSlice.reducer;